<!--
  Pinterest pin = a SELF-CONTAINED copy of the themes-page poster theme card
  (wallpaper + scrim + lone Codigrate logo-half + floating logo + identity
  stack), sized to Pinterest's 2:3 pin ratio. Static: no hover, no click, it's
  only ever screenshotted. Sizes live in the scss (scaled up from the ~300px
  theme card by the same proportions).
-->
<div class="pin"
     *ngIf="product"
     [style.--plugin-primary]="product.designTokens?.primaryColor"
     [style.--plugin-secondary]="product.designTokens?.secondaryColor"
     [style.--panel]="posterPanel"
     [style.--panel-0]="posterPanel0"
     [style.--poster-fg]="posterFg"
     [style.--poster-fg-dim]="posterFgDim"
     [attr.data-key]="product.key">

  <!-- The theme's wallpaper fills the canvas. -->
  <img class="pin-bg" *ngIf="background" [src]="background" [alt]="product.name">

  <div class="pin-content">
    <!-- The whole system lives in ONE glass pill: a decorative Codigrate
         logo-half, the logo, the identity block, then the colour list. -->
    <div class="pin-panel">
      <!-- Lone decorative Codigrate logo half inside the panel, bottom-left. -->
      <svg class="pin-part"
           xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 210 297" aria-hidden="true">
        <path
          style="fill:var(--plugin-primary, var(--theme-color));fill-opacity:1;stroke:none;stroke-width:3.8232"
          d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
      </svg>

      <!-- Cover header: the theme wallpaper across the top of the panel. -->
      <div class="pin-cover" [style.background-image]="background ? ('url(' + background + ')') : null"></div>

      <div class="pin-body">
        <div class="pin-head">
          <!-- Logo straddles the cover's bottom edge (avatar-on-cover). -->
          <img class="pin-logo" *ngIf="product.logo" [src]="product.logo" alt="">

          <div class="pin-identity">
            <span class="pin-category">{{ category }}<ng-container *ngIf="appearance"><span class="pin-dash"></span>{{ appearance }}</ng-container></span>
            <h2 class="pin-name">{{ product.name }}</h2>
            <span class="pin-tags" *ngIf="posterTags">{{ posterTags }}</span>
          </div>

          <p class="pin-desc" *ngIf="plainDescription">{{ plainDescription }}</p>
        </div>

        <div class="pin-colors" *ngIf="colors.length">
          <div class="pin-color-bar" *ngFor="let hex of colors" [style.background-color]="hex">
            <span class="pin-color-bar-hex">{{ hex }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
